import { SHIFT_QUESTION_BATCH_LIST, SHIFT_QUESTION_BATCH_LIST_SUCCESS, SHIFT_QUESTION_BATCH_LIST_ERROR, ADD_BATCH, ADD_BATCH_SUCCESS, ADD_BATCH_ERROR, EDIT_BATCH_ERROR, EDIT_BATCH_SUCCESS, EDIT_BATCH, BATCH_DETAILS, BATCH_DETAILS_SUCCESS, BATCH_DETAILS_ERROR, DELETE_BATCH, DELETE_BATCH_SUCCESS, DELETE_BATCH_ERROR, ADD_QUESTION, ADD_QUESTION_SUCCESS, ADD_QUESTION_ERROR, QUESTION_LIST, QUESTION_LIST_SUCCESS, QUESTION_LIST_ERROR, QUESTION_DETAILS, QUESTION_DETAILS_SUCCESS, QUESTION_DETAILS_ERROR, DELETE_QUESTION, DELETE_QUESTION_SUCCESS, DELETE_QUESTION_ERROR } from './constants';


export default function questionreducer(state, action) {
	
	let batch = [];
	let questions = [];

	switch (action.type) {

	case SHIFT_QUESTION_BATCH_LIST:
		return { ...state, loading : true, error : false};

	case SHIFT_QUESTION_BATCH_LIST_SUCCESS:
		if(action?.payload){
			action.payload.map((item) => {
				
				batch.push({
					id : item && item?.id ? item.id : null,
					name : item && item?.name ?  item.name : '',
				});
			});
		}

		return {...state, batch : batch,  loading : false, error : false};

	case SHIFT_QUESTION_BATCH_LIST_ERROR:
		return { ...state, batch : [], loading : false, error : true};

	case ADD_BATCH:
		return { ...state, loading: true };
	case ADD_BATCH_SUCCESS:
		return { ...state, loading: false, error: false };

	case ADD_BATCH_ERROR:
		return {...state, loading : false, error : true};

	case EDIT_BATCH:
		return { ...state, loading: true, error: false };

	case EDIT_BATCH_SUCCESS:
		return { ...state,  loading: false, error : false };

	case EDIT_BATCH_ERROR:
		return {...state, loading : false, error : true};

	case BATCH_DETAILS:
		return { ...state, loading: true };

	case BATCH_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };

	case BATCH_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_BATCH:
		return { ...state, loading: false };

	case DELETE_BATCH_SUCCESS:
		return { ...state, loading: false, error: false };

	case DELETE_BATCH_ERROR:
		return { ...state, loading: false, error: true };

	case ADD_QUESTION:
		return { ...state, loading: true };

	case ADD_QUESTION_SUCCESS:
		return { ...state, loading: false, error: false };

	case ADD_QUESTION_ERROR:
		return {...state, loading : false, error : true};

	case QUESTION_LIST:
		return { ...state, loading : true, error : false};

	case QUESTION_LIST_SUCCESS:
		if(action?.payload){
			action.payload.map((item) => {
				
				questions.push({
					id : item && item?.id ?  item.id : null,
					text : item && item?.text ?  item.text : ''
				});
			});
		}

		return {...state, questions : questions,  loading : false, error : false};
	
	case QUESTION_LIST_ERROR:
		return { ...state, batch : [], loading : false, error : true};

	case QUESTION_DETAILS:
		return { ...state, loading: true };


	case QUESTION_DETAILS_SUCCESS:
		return { ...state, loading: false, details:action.payload, error: false };


	case QUESTION_DETAILS_ERROR:
		return { ...state, loading: false, error: true };

	case DELETE_QUESTION:
		return { ...state, loading: false };

	case DELETE_QUESTION_SUCCESS:
		return { ...state, loading: false, error: false };

	case DELETE_QUESTION_ERROR:
		return { ...state, loading: false, error: true };

	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}